document.addEventListener('DOMContentLoaded', () => {

    // Smooth Scrolling for Navigation
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    });

    // Intersection Observer for Fade-in Animations
    const fadeElems = document.querySelectorAll('.fade-in, .section-title, .problem-card, .feature-row, .case-item');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                // Optional: Stop observing once visible to run animation only once
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1
    });

    fadeElems.forEach(elem => {
        elem.classList.add('fade-in'); // Ensure all targets have base class
        observer.observe(elem);
    });

    // Number Counter Animation
    const counters = document.querySelectorAll('.counter');
    const counterObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const counter = entry.target;
                const target = +counter.getAttribute('data-target');
                const duration = 2000; // 2 seconds
                const increment = target / (duration / 16); // 60fps

                let current = 0;
                const updateCounter = () => {
                    current += increment;
                    if (current < target) {
                        counter.innerText = Math.ceil(current).toLocaleString();
                        requestAnimationFrame(updateCounter);
                    } else {
                        counter.innerText = target.toLocaleString();
                    }
                };
                updateCounter();
                counterObserver.unobserve(counter);
            }
        });
    }, {
        threshold: 0.5
    });

    counters.forEach(counter => {
        counterObserver.observe(counter);
    });

    // Simple sticky header background on scroll
    const header = document.querySelector('.header');
    window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
            header.style.background = 'rgba(255, 255, 255, 0.95)';
            header.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
        } else {
            header.style.background = 'rgba(255, 255, 255, 0.9)';
            header.style.boxShadow = 'none';
        }
    });

    // Slider Click & Arrow Scrolling Logic
    const sliderContainers = document.querySelectorAll('.store-slider-container');

    sliderContainers.forEach(container => {
        const slider = container.querySelector('.store-slider');
        const slides = container.querySelectorAll('.store-slide');
        const leftArrow = container.querySelector('.slider-arrow-left');
        const rightArrow = container.querySelector('.slider-arrow-right');

        // Calculate dynamic slide width + gap for scrolling distance
        const getScrollAmount = () => {
            if (slides.length > 0) {
                return slides[0].offsetWidth + 20; // 20px is the gap
            }
            return 300; // fallback
        };

        // Arrow Clicks
        if (leftArrow) {
            leftArrow.addEventListener('click', () => {
                slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
            });
        }

        if (rightArrow) {
            rightArrow.addEventListener('click', () => {
                slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
            });
        }

        // Image/Slide Clicks (Scroll to next/prev depending on click position relative to center)
        slides.forEach(slide => {
            slide.addEventListener('click', (e) => {
                // Determine if we clicked the right half or left half of the visible slider area
                const clickX = e.clientX;
                const containerRect = container.getBoundingClientRect();
                const containerCenter = containerRect.left + (containerRect.width / 2);

                if (clickX > containerCenter) {
                    // Clicked on the right side - scroll right
                    slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
                } else {
                    // Clicked on the left side - scroll left
                    slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
                }
            });
        });

        // Optional: Hide arrows if at the start/end
        const updateArrows = () => {
            if (slider.scrollLeft <= 5) {
                if (leftArrow) leftArrow.style.opacity = '0';
                if (leftArrow) leftArrow.style.pointerEvents = 'none';
            } else {
                if (leftArrow) leftArrow.style.opacity = '1';
                if (leftArrow) leftArrow.style.pointerEvents = 'auto';
            }

            // Check if reached end
            if (slider.scrollLeft >= (slider.scrollWidth - slider.clientWidth - 5)) {
                if (rightArrow) rightArrow.style.opacity = '0';
                if (rightArrow) rightArrow.style.pointerEvents = 'none';
            } else {
                if (rightArrow) rightArrow.style.opacity = '1';
                if (rightArrow) rightArrow.style.pointerEvents = 'auto';
            }
        };

        // Listen to scroll to update arrow visibility
        slider.addEventListener('scroll', updateArrows);
        // Initial setup
        updateArrows();
        // Update on resize
        window.addEventListener('resize', updateArrows);
    });
});
